import { arrayOf, object, string } from "prop-types";
import Tabs from "../Tabs/Tabs.jsx";
import TopicCard from "./TopicCard.jsx";

const propTypes = {
  cardEyebrow: string.isRequired,
  disabledLegend: string.isRequired,
  topics: arrayOf(object),
};

const ExploreTopicsTabs = (props) => {
  const { topics, ...rest } = props;
  return (
    <Tabs>
      {topics.map((topic, index) => (
        <div label={topic.title} key={index + topic.title}>
          <TopicCard topic={topic} {...rest} />
        </div>
      ))}
    </Tabs>
  );
};

ExploreTopicsTabs.propTypes = propTypes;
export default ExploreTopicsTabs;
